import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventEventIdNotesLayoutRoute() {
  return <ModalStack />;
}
